import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, CardActions, Button } from '@material-ui/core';
import CudaPaper from 'common/components/CudaPaper'
import { ReloadIcon } from 'common/components/icons';
import { ConnectClusterPanel }from './ClustersContainer'
import { Alert, AlertTitle } from '@material-ui/lab';

const styles = {
    actions: {
        padding: '10px',
        marginTop: '-10px',
    },
    alertBox:{
        width: "100%",
    }
};

const Clusters = ({ classes, fetcher, clustersDict, reload, traffic_managers_info }) => {
    try{
	const renderError = (errorKey, error) => {
		switch(errorKey) {
			case 'missing_infra_pods':
				let controllers = error['controller_names'].join(", ")
				return <><strong>Missing infrastructure controllers in pod</strong>: {error['node']} <strong>missing controllers:</strong> {controllers}<br/></>	
			default:
				return <><strong>General Error</strong>: Unexpected error received: {errorKey}<br/></>
		}
	}

	const renderWarning = (warningKey, warning) => {
		switch(warningKey) {
			case 'status_error':
				let con_stat_reason = warning['container_status_reason'] ? "<strong>Container Status Reason: </strong>{warning['container_status_reason']}, " : ""
				let con_status = warning['container'] ? "<strong>Container Status: </strong>{warning['container']}, " : ""
				return <><strong>Status Warning for pod</strong>: {warning['pod_name']} <strong>Pod Status: </strong>{warning['pod_status']}, {con_status}
				{con_stat_reason} <strong>Controller: </strong>{warning['controller_name']}</>
            case 'high_restart_count':
                return <>There are <strong>pods/containers</strong> with a <strong>high restart count: </strong>{warning}<br/></>	
			default:
				return <><strong>General Warning</strong>: Unexpected warning received: {warningKey}<br/></>
		}
	}

    let clusters = 'clusters' in clustersDict ? clustersDict['clusters'] : []
    let issues = 'issues' in clustersDict ? clustersDict['issues'] : {}
	let errors = 'errors' in issues ? issues['errors'] : {}
	let warnings = 'warnings' in issues ? issues['warnings'] : {}

    return <CudaPaper loading={fetcher.loading}>
        <CardActions className={classes.actions} disableactionspacing="true">
            Container Clusters
            <Button onClick={reload}>
                <ReloadIcon />
            </Button>
        </CardActions>
        <Grid container>
            {/* Global errors */}
            {(Object.keys(errors).length !== 0) && 
            <Alert severity='error' className={classes.alertBox}>
                <AlertTitle>Errors</AlertTitle>
                {Object.keys(errors).map((e) => 			
                    <Grid item xs={12} key={e}>
                        {renderError(e, errors[e])}
                    </Grid>)
                }
            </Alert> }
            {/* Global warnings */}
            {(Object.keys(warnings).length !== 0) && 
            <Alert severity='warning' className={classes.alertBox}>
                <AlertTitle>Warnings</AlertTitle>
                {Object.keys(warnings).map((w) => 
                    <Grid item xs={12} key={w}>
                        {renderWarning(w, warnings[w])}
                    </Grid>)
                }
            </Alert>}
            {/* Region Panels */}
            {clusters.map((c) =>
                <Grid item xs={12} key={c['id']}>
                    <ConnectClusterPanel clusterId={c['id']} clusterData={c} traffic_managers_info={traffic_managers_info}/>
                </Grid>
            )}
        </Grid>    
    </CudaPaper>
    }catch(e){
        console.log('Error loading clusters component: ' + e);
        return <></>
    }
};

export default withStyles(styles)(Clusters);
